// import axios from "axios";
// import { CalendarEvent } from "../utils/types";
// import baseUrl from "../config/baseURL";
// import { getAuthToken } from "../services/auth";

// let token = await getAuthToken();
//     try {
//         if(token){
//             let header_token = "Bearer " + token.data;
//             const headers = {
//                 Authorization: header_token,
//             };

// const api = axios.create({
//   baseURL: process.env.REACT_APP_API_BASE_URL || "/api",
//   headers: { "Content-Type": "application/json" },
// });

// export const setAuthToken = (token?: string) => {
//   if (token) api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
//   else delete api.defaults.headers.common["Authorization"];
// };

// // ✅ Require orgId in all requests
// export const fetchEvents = (
//   organizationId: string,
//   params?: Record<string, any>
// ) => {
//   if (!organizationId) throw new Error("Organization ID is required");
//   return api.get<CalendarEvent[]>(
//     `${baseUrl}/core/organizations/${organizationId}/calendar-events/`,
//     { params }
//   );
// };

// export const createEvent = (
//   organizationId: string,
//   payload: Partial<CalendarEvent>
// ) => {
//   if (!organizationId) throw new Error("Organization ID is required");
//   return api.post<CalendarEvent>(
//     `${baseUrl}/core/organizations/${organizationId}/calendar-events/`,
//     payload
//   );
// };

// export const updateEvent = (
//   organizationId: string,
//   id: string,
//   payload: Partial<CalendarEvent>
// ) => {
//   if (!organizationId) throw new Error("Organization ID is required");
//   return api.patch<CalendarEvent>(
//     `${baseUrl}/core/organizations/${organizationId}/calendar-events/${id}/`,
//     payload
//   );
// };

// export const deleteEvent = (organizationId: string, id: string) => {
//   if (!organizationId) throw new Error("Organization ID is required");
//   return api.delete<void>(
//     `${baseUrl}/core/organizations/${organizationId}/calendar-events/${id}/`
//   );
// };

import axios from "axios";
import { CalendarEvent } from "../utils/types";
import baseUrl from "../config/baseURL";
import { getAuthToken } from "../services/auth";

// Create axios instance
const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || "/api",
  headers: { "Content-Type": "application/json" },
});

// Set auth token for all requests
export const setAuthToken = (token?: string) => {
  if (token) api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  else delete api.defaults.headers.common["Authorization"];
};

// Initialize token on app start
export const initAuthToken = async () => {
  const token = await getAuthToken();
  if (token?.success && token.data) setAuthToken(token.data);
};

// ✅ Require orgId in all requests
export const fetchEvents = async (
  organizationId: string,
  params?: Record<string, any>
) => {
  if (!organizationId) throw new Error("Organization ID is required");
  await initAuthToken();
  return api.get<CalendarEvent[]>(
    `${baseUrl}/core/organizations/${organizationId}/calendar-events/`,
    { params }
  );
};

export const createEvent = async (
  organizationId: string,
  payload: Partial<CalendarEvent>
) => {
  if (!organizationId) throw new Error("Organization ID is required");
  await initAuthToken();
  return api.post<CalendarEvent>(
    `${baseUrl}/core/organizations/${organizationId}/calendar-events/`,
    payload
  );
};

export const fetchEvent = async (organizationId: string, id: string) => {
  if (!organizationId) throw new Error("Organization ID is required");
  await initAuthToken();
  return api.get<CalendarEvent>(
    `${baseUrl}/core/organizations/${organizationId}/calendar-events/${id}/`
  );
};

export const updateEvent = async (
  organizationId: string,
  id: string,
  payload: Partial<CalendarEvent>
) => {
  if (!organizationId) throw new Error("Organization ID is required");
  await initAuthToken();
  return api.patch<CalendarEvent>(
    `${baseUrl}/core/organizations/${organizationId}/calendar-events/${id}/`,
    payload
  );
};

export const deleteEvent = async (organizationId: string, id: string) => {
  if (!organizationId) throw new Error("Organization ID is required");
  await initAuthToken();
  return api.delete<void>(
    `${baseUrl}/core/organizations/${organizationId}/calendar-events/${id}/`
  );
};
